import { useState } from "react";
import { Container, Paper, TableContainer, TableHead, TableBody, TableRow, TableCell, Table, Alert, Skeleton } from "@mui/material";
import { useDispatch, useSelector } from 'react-redux';
import { reportStudents } from "../../features/reports/reportsSlice";
import { TitleWSelect } from "../Tools";

const initialState = { 
    report: [], 
    totals: { total: 0, hombres: 0, mujeres: 0, indigenas: 0 } 
}

const ReportStudents = () => {
    const { isLoading } = useSelector(state => state.progress);
    const dispatch = useDispatch();
    const [option, setOption] = useState('')
    const [data, setData] = useState(initialState)
    const { report, totals } = data;
    const options = [{ id: 1, nombre: 'Alumnos' }, { id: 2, nombre: 'Egresados' }]

    const handleChange = event => {
        const id = event.target.value
        setOption(id)
        if(id) reportStudents(id, dispatch, setData)
        else setData(initialState)
    }
    return(
        <Container component={Paper} sx={{ p: '2em', mb: '2em' }} maxWidth='xl'>
            <TitleWSelect title={'REPORTE DE ESTUDIANTES'} label="Estatus" year={option} options={options} handleChange={handleChange} />
            { isLoading ? <Skeleton animation='wave' height={200} /> : totals.total ? (
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">GENERACIÓN</TableCell>
                                <TableCell align="center">TOTAL</TableCell>
                                <TableCell align="center">HOMBRES</TableCell>
                                <TableCell align="center">MUJERES</TableCell>
                                <TableCell align="center">INDIGENAS</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            { report.map(({ calendario, total, hombres, mujeres, indigenas }, i) => (
                                <TableRow key={i}>
                                    <TableCell align="center"><b>{calendario}</b></TableCell>
                                    <TableCell align="center"><b>{total}</b></TableCell>
                                    <TableCell align="center">{hombres}</TableCell>
                                    <TableCell align="center">{mujeres}</TableCell>
                                    <TableCell align="center">{indigenas}</TableCell>
                                </TableRow>
                            )) }
                        </TableBody>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">TOTAL</TableCell>
                                <TableCell align="center">{totals.total}</TableCell>
                                <TableCell align="center">{totals.hombres}</TableCell>
                                <TableCell align="center">{totals.mujeres}</TableCell>
                                <TableCell align="center">{totals.indigenas}</TableCell>
                            </TableRow>
                        </TableHead>
                    </Table>
                </TableContainer>
            ) : option === '' ? null : <Alert severity="warning">No se encontraron resultados</Alert>  }
        </Container>
    )
}

export default ReportStudents;